import React, { useEffect, useState } from "react";
import api from "../utils/base_url";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { addCart, delCart } from "../redux/action";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import StockNotifyModal from "./StockNotifyModal";

const OfferModal = () => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedCat, setSelectedCat] = useState("all");
    const [filtered, setFiltered] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [favorites, setFavorites] = useState([]);

    const [stockError, setStockError] = useState({});
    const [disabledQty, setDisabledQty] = useState({});

    const [notifyModal, setNotifyModal] = useState(false);
    const [notifyProduct, setNotifyProduct] = useState(null);
    const [notifyForm, setNotifyForm] = useState({
        email: "",
        quantity: "",
    });


    const [animatingHeart, setAnimatingHeart] = useState(null);

    const { user } = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const state = useSelector((state) => state.handleCart);

    const badgeStyle = {
        position: "absolute",
        top: "8px",
        left: "38%",
        transform: "translateX(-50%)",
        padding: "6px 14px",
        background: "#dc3545",
        color: "white",
        borderRadius: "20px",
        fontSize: "0.8rem",
        fontWeight: 600,
        zIndex: 99,
        whiteSpace: "nowrap",
        boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
    };

    // API call for offer products by page/category
    const fetchOfferProducts = async (
        category = "all"
    ) => {
        setLoading(true);

        try {
            const res = await api.get(
                "offer-products/"
            );

            const products =
                res.data?.data || [];

            // unique categories
            const cats = [
                ...new Set(
                    products.map(
                        p => p.category_name
                    )
                ),
            ];

            setCategories(cats);

            // category filter
            const filteredProducts =
                category &&
                    category !== "all"
                    ? products.filter(
                        p =>
                            p.category_name ===
                            category
                    )
                    : products;

            setFiltered(
                filteredProducts
            );

            // fake pagination fallback
            setPage(1);
            setTotalPages(1);
        } catch (err) {
            console.error(
                "Offer API error:",
                err
            );

            setFiltered([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchFavorites = React.useCallback(async () => {
        if (!user) return;
        try {
            const res = await api.get(`favorites/ids/?auth_id=${user.id}`);
            setFavorites(res.data.favorites || []);
        } catch { }
    }, [user]);

    useEffect(() => {
        if (show) fetchFavorites();
    }, [show, fetchFavorites]);



    const toggleFavorite = async (productId) => {
        if (!user) {
            toast.error("Please login first!");
            navigate("/login");
            return;
        }

        try {
            const res = await api.post("favorites/toggle/", {
                product_id: productId,
                auth_id: user.id
            });
            const isFav = res.data.is_favorite ?? res.data.favorite ?? false;


            setFavorites((prev) =>
                isFav ? [...prev, productId] : prev.filter((id) => id !== productId)
            );
            setAnimatingHeart(productId);

            // Reset animation after 400ms
            setTimeout(() => setAnimatingHeart(null), 400);
            fetchFavorites();
        } catch {
            toast.error("Failed. Try again.");
        }
    };
    useEffect(() => {
        if (show) {
            fetchOfferProducts(
                selectedCat
            );
        }
    }, [show, selectedCat]);

    const handleCategory = cat => {
        setSelectedCat(cat);
        setPage(1); // Reset to page 1 when category changes
        fetchOfferProducts(cat);
    };

    const handlePageChange = pageNum => {
        setPage(pageNum);
    };

    const getCartQty = (productId) => {
        const item = state.find((p) => p.id === productId);
        return item ? item.qty : 0;
    };

    const addItem = (product) => {
        const available =
            product.available_stock ??
            product.stock_quantity;

        const nextQty =
            getCartQty(product.id) + 1;

        if (nextQty > available) {
            setStockError(prev => ({
                ...prev,
                [product.id]: true,
            }));

            setDisabledQty(prev => ({
                ...prev,
                [product.id]: true,
            }));

            setTimeout(() => {
                setStockError(prev => ({
                    ...prev,
                    [product.id]: false,
                }));

                setDisabledQty(prev => ({
                    ...prev,
                    [product.id]: false,
                }));
            }, 2000);

            return;
        }

        dispatch(addCart(product));
    };

    const removeItem = (product) => {
        dispatch(delCart(product));
        setStockError(prev => {
            const newState = { ...prev };
            delete newState[product.id];
            return newState;
        });
    };

    const isMobile = window.innerWidth <= 767;

    return (
        <>
            {/* --- Floating Offers Tab with Discount Tag Icon --- */}
            <button
                onClick={() => setShow(true)}
                style={{
                    position: "fixed",
                    right: 0,
                    top: "45%",
                    zIndex: 3000,
                    background: "linear-gradient(180deg, #4A1F1A 0%, #8A4B27 100%)",
                    color: "#fff",
                    fontWeight: 700,
                    height: 110,
                    width: 36,
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    borderRadius: "10px 0 0 10px",
                    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                        "linear-gradient(180deg, #8A4B27 0%, #4A1F1A 100%)";
                    e.currentTarget.style.transform = "translateX(-3px)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                        "linear-gradient(180deg, #8A4B27 0%, #4A1F1A 100%)";
                    e.currentTarget.style.transform = "translateX(0)";
                }}
            >
                <div
                    style={{
                        transform: "rotate(-90deg) translateY(6px)", // <-- pushes content down a bit after rotation
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                    }}
                >
                    <span
                        style={{
                            letterSpacing: "1.2px",
                            fontSize: "1rem",
                            fontFamily: "'Poppins', sans-serif",
                            lineHeight: 1,
                            userSelect: "none",
                        }}
                    >
                        Offers
                    </span>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1.3em"
                        height="1.3em"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        style={{ color: "#fff" }}
                    >
                        <path d="M2 3a1 1 0 0 1 1-1h8a1 1 0 0 1 .707.293l10 10a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-10-10A1 1 0 0 1 2 11V3zm2 1v6.586l9 9L19.586 13l-9-9H4z" />
                        <path d="M9 7.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0z" />
                    </svg>
                </div>

                {/* Bottom angled cut */}
                {/* <span
                    style={{
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        width: 0,
                        height: 0,
                        borderBottom: "12px solid transparent",
                        borderLeft: "12px solid #567a0fff",
                    }}
                /> */}
            </button>




            {/* --- Modal --- */}
            {show && (
                <>
                    <div
                        className="offer-modal-backdrop"
                        onClick={() => setShow(false)}
                        style={{
                            position: "fixed",
                            inset: 0,
                            background: "rgba(80, 38, 17, 0.21)",
                            zIndex: 5020,
                        }}
                    ></div>
                    <div
                        className="offer-modal-content offer-modal-scope"

                        style={{
                            position: "fixed",
                            right: 0,
                            top: isMobile ? "auto" : 0,
                            bottom: isMobile ? 0 : "auto",
                            width: isMobile ? "100vw" : "48vw",
                            height: isMobile ? "100vh" : "100vh",
                            borderRadius: isMobile ? "24px 24px 0 0" : "16px 0px 0px 16px",
                            boxShadow: "0 8px 24px rgba(122,86,58,.10)",
                            background: "#E9DCC3",
                            zIndex: 5022,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "auto",
                            animation: isMobile ? "slideUpOffer .42s" : "slideLeftOffer .32s",
                            maxWidth: isMobile ? "100vw" : "470px",
                            maxHeight: "100vh",
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        <div
                            className="modal-header-themed"
                            style={{
                                padding: "22px 22px 0 22px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <h3 style={{ fontWeight: 700, color: "#4A1F1A", fontSize: "1.2rem", margin: 0 }}>Offer Products</h3>
                            <button
                                className="btn-close-themed"
                                style={{ fontSize: "2rem", border: "none", background: "transparent", cursor: "pointer", color: "#4A1F1A", fontWeight: 700 }}
                                onClick={() => setShow(false)}
                            >
                                ×
                            </button>
                        </div>

                        {/* Special Stencil & Cone Deals Quick Banner */}
                        <div
                            onClick={() => {
                                setShow(false);
                                window.dispatchEvent(new CustomEvent("vk_open_offer_modal"));
                            }}
                            style={{
                                margin: "14px 18px 0 18px",
                                padding: "10px 14px",
                                background: "linear-gradient(135deg, #4A1F1A 0%, #8A4B27 100%)",
                                borderRadius: "12px",
                                color: "#fff",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                border: "1.5px solid #D4AF37",
                                boxShadow: "0 4px 12px rgba(74, 31, 26, 0.25)",
                                transition: "transform 0.2s ease"
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ fontSize: "1.3rem" }}>✨</span>
                                <div>
                                    <div style={{ fontSize: "0.85rem", fontWeight: 700, color: "#FFD700" }}>Mandala & Bridal Gift Offers (Oct 6 – Nov 6 Only)</div>
                                    <div style={{ fontSize: "0.72rem", color: "#FFF9F0" }}>Free Bridal Cones & Henna Dips on Stencils • Limited Time</div>
                                </div>
                            </div>
                            <span style={{ fontSize: "0.74rem", background: "#D4AF37", color: "#2A0E0B", fontWeight: 800, padding: "4px 10px", borderRadius: "12px" }}>
                                View Deals
                            </span>
                        </div>
                        {/* Category Group */}
                        <div style={{ padding: "18px 18px 0 18px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                            <button
                                className={`cat-btn ${selectedCat === "all" ? "active" : ""}`}
                                style={{ borderRadius: 8, padding: "6px 16px", border: "1.3px solid #4A1F1A", background: selectedCat === "all" ? "#4A1F1A" : "#fff", color: selectedCat === "all" ? "#fff" : "#4A1F1A", fontWeight: 600, fontSize: ".95rem", transition: "all 0.3s", cursor: "pointer" }}
                                onClick={() => handleCategory("all")}
                            >
                                All
                            </button>
                            {categories.map(cat => (
                                <button
                                    key={cat}
                                    className={`cat-btn ${selectedCat === cat ? "active" : ""}`}
                                    style={{ borderRadius: 8, padding: "6px 16px", border: "1.3px solid #4A1F1A", background: selectedCat === cat ? "#4A1F1A" : "#fff", color: selectedCat === cat ? "#ffffff" : "#4A1F1A", fontWeight: 600, fontSize: ".95rem", transition: "all 0.3s", cursor: "pointer" }}
                                    onClick={() => handleCategory(cat)}
                                >
                                    {cat}
                                </button>
                            ))}
                        </div>
                        {/* Grid */}
                        <div
                            className="offer-grid"
                            style={{
                                display: "grid",
                                gap: "18px",
                                padding: "18px 14px",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                borderRadius: "12px"
                            }}
                        >
                            {loading
                                ? [...Array(4)].map((_, idx) => (
                                    <div key={idx} className="skeleton-card">
                                        <Skeleton height={280} />
                                    </div>
                                ))
                                : filtered.length === 0 ? (
                                    <div style={{ textAlign: "center", gridColumn: "span 2", color: "#4A1F1A", fontWeight: 600 }}>
                                        No offer products found.
                                    </div>

                                ) : (
                                    filtered.map((product, idx) => {
                                        const available =
                                            product.available_stock ??
                                            product.stock_quantity;

                                        const outOfStock =
                                            available === 0;

                                        const lowStock =
                                            available <= 2 &&
                                            available > 0;
                                        return (
                                            <div
                                                key={product.id}
                                                className="product-card "

                                                onClick={() => {

                                                    setShow(false);

                                                    sessionStorage.setItem(
                                                        "products_scroll_y",
                                                        window.scrollY
                                                    );

                                                    navigate(
                                                        `/product/${product.id}`
                                                    );
                                                }}

                                            >
                                                {/* ❤️ Favorite Icon */}
                                                <motion.div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleFavorite(product.id);
                                                    }}
                                                    initial={{ scale: 1 }}
                                                    whileTap={{ scale: 0.9 }}   // <-- keep tap animation only
                                                    animate={{}}
                                                    transition={{ duration: 0.25 }}
                                                    style={{
                                                        position: "absolute",
                                                        top: "10px",
                                                        right: "10px",
                                                        cursor: "pointer",
                                                        zIndex: 50,
                                                    }}
                                                >
                                                    {user ? (
                                                        <div
                                                            style={{
                                                                width: "26px",
                                                                height: "26px",
                                                                borderRadius: "50%",
                                                                backgroundColor: "#E9DCC3",
                                                                boxShadow: "0 2px 6px #4A1F1A",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                transition: "all 0.25s ease",
                                                                backdropFilter: "blur(3px)",
                                                                cursor: "pointer",
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.boxShadow = "0 2px 8px  #4A1F1A"; // gray hover shadow
                                                                e.currentTarget.style.transform = "scale(1.08)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                                                                e.currentTarget.style.transform = "scale(1)";
                                                            }}
                                                        >
                                                            {favorites.includes(product.id) ? (
                                                                <motion.span
                                                                    animate={animatingHeart === product.id ? { scale: [1, 1.4, 1] } : {}}
                                                                    transition={{ duration: 0.3 }}
                                                                    style={{
                                                                        color: "#e63946",
                                                                        fontSize: "12px",
                                                                    }}
                                                                >
                                                                    ❤️
                                                                </motion.span>
                                                            ) : (
                                                                <span
                                                                    style={{
                                                                        color: "#4A1F1A",
                                                                        fontSize: "12px",
                                                                    }}
                                                                >
                                                                    🤍
                                                                </span>
                                                            )}
                                                        </div>
                                                    ) : null}

                                                </motion.div>


                                                {/* 🔥 Offer Badge */}
                                                {product.offer_percentage && (
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: 100,
                                                            left: 0,
                                                            background: "linear-gradient(135deg, #567a0fff, #2E7D32)",
                                                            color: "#fff",
                                                            padding: "2px 5px",
                                                            fontSize: ".75rem",
                                                            fontweight: "600",
                                                            borderRadius: "0 6px 6px 0",
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        {Math.round(product.offer_percentage)}% OFF
                                                    </span>
                                                )}
                                                {outOfStock && (
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: 45,
                                                            left: 0,
                                                            background: "#dc3545",
                                                            color: "#fff",
                                                            padding: "4px 12px",
                                                            fontSize: "0.75rem",
                                                            fontWeight: 600,
                                                            borderRadius: "0 6px 6px 0",
                                                            zIndex: 12
                                                        }}
                                                    >
                                                        Out of Stock
                                                    </span>
                                                )}

                                                {!outOfStock && lowStock && (
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: 10,
                                                            left: 0,
                                                            background: "#ffc107",
                                                            color: "#000",
                                                            padding: "4px 12px",
                                                            fontSize: "0.75rem",
                                                            fontWeight: 600,
                                                            borderRadius: "0 6px 6px 0",
                                                            zIndex: 12
                                                        }}
                                                    >
                                                        Hurry! Only {available} left
                                                    </span>
                                                )}
                                                {stockError[product.id] && (
                                                    <motion.div
                                                        initial={{ x: 100, opacity: 0 }}
                                                        animate={{
                                                            x: [100, 0, -6, 6, -6, 6, 0],  // slide in + shake
                                                            opacity: 1,
                                                        }}
                                                        transition={{
                                                            duration: 0.6,
                                                            ease: "easeOut",
                                                        }}
                                                        exit={{
                                                            x: -100,
                                                            opacity: 0,
                                                            transition: { duration: 0.3 }
                                                        }}
                                                        style={badgeStyle}
                                                    >
                                                        Stock limit reached!
                                                    </motion.div>


                                                )}
                                                <div
                                                    className="img-wrapper"
                                                    style={{
                                                        height: 150,
                                                        background: "#E9DCC3",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <img
                                                        src={product.product_image}
                                                        alt={product.product_name}
                                                        style={{
                                                            width: "80%",
                                                            height: "100%",
                                                            objectFit: "contain",
                                                            transition: "transform .32s",
                                                            backgroundColor: "#E9DCC3",
                                                        }}
                                                        className="offer-img"
                                                    />
                                                </div>

                                                <div className="product-content" style={{ textAlign: "center", padding: 12 }}>
                                                    <h5 className="product-title" style={{ fontWeight: 700 }}>
                                                        {product.product_name.length > 15
                                                            ? product.product_name.slice(0, 15) + "..."
                                                            : product.product_name}
                                                    </h5>

                                                    <div className="product-price-wrap" style={{ marginTop: 8 }}>
                                                        {product.offer_price ? (
                                                            <>
                                                                <span className="product-price-offer">
                                                                    ₹ {parseFloat(product.offer_price).toLocaleString()}
                                                                </span>
                                                                <span className="product-price-original">
                                                                    <s>₹ {parseFloat(product.price).toLocaleString()}</s>
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span className="product-price">
                                                                ₹ {parseFloat(product.price).toLocaleString()}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="product-btns">
                                                    <div className="product-btns" onClick={(e) => e.stopPropagation()}>
                                                        {outOfStock ? (
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    gap: "8px",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <button
                                                                    className="notify-btn"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setNotifyProduct(product);
                                                                        setNotifyForm({
                                                                            email: "",
                                                                            quantity: "",
                                                                        });
                                                                        setNotifyModal(true);
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: "16px" }}>🔔</span>
                                                                    Notify Me
                                                                </button>
                                                            </div>
                                                        ) : getCartQty(product.id) === 0 ? (
                                                            <button
                                                                className="btn-buy"
                                                                onClick={() => addItem(product)}
                                                            >
                                                                Add to Cart
                                                            </button>
                                                        ) : (
                                                            <div className="qty-box">
                                                                <button className="qty-btn" onClick={() => removeItem(product)}>
                                                                    <i className="fas fa-minus"></i>
                                                                </button>
                                                                <span className="qty-value">{getCartQty(product.id)}</span>
                                                                <button
                                                                    className="qty-btn"
                                                                    onClick={() => addItem(product)}
                                                                    disabled={disabledQty[product.id]}
                                                                >
                                                                    <i className="fas fa-plus"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        );
                                    })
                                )}
                        </div>
                        {/* Pagination */}
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "16px",
                            padding: "12px 12px 28px",
                            width: "100%"
                        }}>
                            <div >

                                <button
                                    className="pagenation-button"
                                    disabled={page === 1}
                                    onClick={() => handlePageChange(page - 1)}
                                >
                                    ‹ Prev
                                </button>
                            </div>
                            <button
                                className="pagenation-button"
                                disabled={page === totalPages}
                                onClick={() => handlePageChange(page + 1)}
                            >
                                Next ›
                            </button>
                        </div>
                    </div>
                    <style>{`
                    
      .qty-btn {
        background: #8A4B27;
        color: white;
        border: none;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

            @keyframes slideLeftOffer {
              from {transform: translateX(100vw);}
              to {transform: translateX(0);}
            }
            @keyframes slideUpOffer {
              from {transform: translateY(100vh);}
              to {transform: translateY(0);}
            }
            @media (max-width: 768px) {
              .offer-vertical-label {
                height: 90px !important;
                width: 42px !important;
                font-size: 0.9rem !important;
              }
              .offer-vertical-label span {
                font-size: 0.9rem !important;
              }
            }
            @media (max-width: 480px) {
              .offer-vertical-label {
                height: 75px !important;
                width: 38px !important;
              }
              .offer-vertical-label span {
                font-size: 0.8rem !important;
              }
            }
      .qty-box {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #fff;
        border: 1.5px solid #4A1F1A;
        border-radius: 8px;
        padding: 4px 10px;
      }

             /* Only inside Offer Modal */
        .offer-modal-scope .product-card {
        position: relative;
        background: #E9DCC3;
        border-radius: 12px;
        overflow: hidden;
        border: 1.5px solid #4A1F1A;
        }

        .pagenation-button {
        border-radius: 8px;
        padding: 6px 18px;
        background: #E9DCC3;
        color: #4A1F1A;
        border: none;
        font-weight: 600;
        font-size: 0.92rem;
        cursor: pointer;
        opacity: 1;
        transition: all 0.25s ease;
        }

        .pagenation-button:disabled {
        cursor: not-allowed;
        opacity: 0.7;
        }


/* Offer badge */
        .offer-modal-scope .offer-badge {
        position: absolute;
        top: 10px;
        left: 0;
        background: linear-gradient(135deg, #567a0fff, #2E7D32);
        color: #fff;
        padding: 2px 5px;
        font-size: .75rem;
        font-weight: 600;
        border-radius: 0 6px 6px 0;
        z-index: 10;
        }

/* Stock badge */
.offer-modal-scope .stock-badge {
  position: absolute;
  left: 0;
  top: 45px;
  padding: 4px 12px;
  border-radius: 0 6px 6px 0;
  font-weight: 600;
  font-size: 0.75rem;
  z-index: 12;
}

/* Image wrapper */
.offer-modal-scope .img-wrapper {
  width: 100%;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* Product content */
.offer-modal-scope .product-content {
  padding: 12px;
  text-align: center;
}

/* Price styling */
.offer-modal-scope .product-price-offer {
  color: #4A1F1A;
  font-weight: 700;
}
.offer-modal-scope .product-price-original {
  color: #b33a3a;
  margin-left: 4px;
}
.offer-modal-scope .product-price {
  color: #2E7D32;
  font-weight: 600;
}

/* Buttons inside modal */
.offer-modal-scope .btn-buy {
  background-color: #4A1F1A;
  color: #fff;
  border-radius: 8px;
  padding: 5px 12px;
  border: none;
}

.offer-modal-scope .btn-buy:hover {
  background-color: #8A4B27;
}

.offer-modal-scope .btn-cart {
  background: #f1e6d4;
  color: #2E7D32;
  border-radius: 25px;
  padding: 5px 12px;
  border: none;
}

        
          `}</style>
                    <StockNotifyModal
                        open={notifyModal}
                        onClose={() => setNotifyModal(false)}
                        product={notifyProduct}
                        notifyForm={notifyForm}
                        setNotifyForm={setNotifyForm}
                        navigate={navigate}
                    />
                </>
            )}
        </>
    );
};

export default OfferModal;
